import React, { useState } from "react";
import { useUser } from '@clerk/clerk-react';
import IndividualLawyerDashboard from './IndividualLawyerDashboard';
import LawFirmDashboard from './LawFirmDashboard';

const DashboardHome = () => {
  const { isLoaded } = useUser();
  const [userType, setUserType] = useState('individual'); // 'individual' or 'lawfirm'

  // Show loading state while user data is being fetched
  if (!isLoaded) {
    return (
      <div className="space-y-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <h1 className="text-2xl md:text-3xl font-semibold text-gray-800">Loading...</h1>
        </div>
      </div>
    );
  }

  // For now, we'll use a simple state to determine user type
  // In a real app, this would come from user metadata or database
  const isIndividualLawyer = userType === 'individual';

  return (
    <div className="h-full">
      {/* Toggle for testing - remove in production */}
      <div className="p-4 bg-gradient-to-b from-white/70 via-white/40 to-white/30 backdrop-blur-xl border-b border-white/30 shadow-sm">
        <div className="flex items-center justify-between">
          <p className="text-sm text-gray-700">
            <strong>Testing Mode:</strong> Toggle between individual lawyer and law firm views
          </p>
          <div className="flex gap-2">
            <button
              onClick={() => setUserType('individual')}
              className={`px-3 py-1 text-xs rounded transition-colors ${
                userType === 'individual' 
                  ? 'bg-gradient-to-r from-gray-700 to-gray-500 text-white shadow-sm' 
                  : 'bg-white/50 text-gray-700 hover:bg-white/70'
              }`}
            >
              Individual
            </button>
            <button
              onClick={() => setUserType('lawfirm')}
              className={`px-3 py-1 text-xs rounded transition-colors ${
                userType === 'lawfirm' 
                  ? 'bg-gradient-to-r from-gray-700 to-gray-500 text-white shadow-sm' 
                  : 'bg-white/50 text-gray-700 hover:bg-white/70'
              }`}
            >
              Law Firm
            </button>
          </div>
        </div>
      </div>

      <div className="h-full">
        {isIndividualLawyer ? (
          <IndividualLawyerDashboard />
        ) : (
          <LawFirmDashboard />
        )}
      </div>
    </div>
  );
};

export default DashboardHome;


